/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Faq_Q5Inputs */

const en_directory_home_faq_q5 = /** @type {(inputs: Directory_Home_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does paying guarantee a listing?`)
};

const zh_directory_home_faq_q5 = /** @type {(inputs: Directory_Home_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`付费就一定能被收录吗？`)
};

/**
* | output |
* | --- |
* | "Does paying guarantee a listing?" |
*
* @param {Directory_Home_Faq_Q5Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_faq_q5 = /** @type {((inputs?: Directory_Home_Faq_Q5Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Faq_Q5Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_faq_q5(inputs)
	return zh_directory_home_faq_q5(inputs)
});
export { directory_home_faq_q5 as "directory.home.faq.q5" }